import React, { useState } from 'react'
import styled from 'styled-components'
import { TabListItem } from '../TabListItem'

export const ProductContent = ({
  tabs,
  description,
}: {
  tabs: any[]
  description: string
}) => {
  const [tabOpen, setTabOpen] = useState(description)

  const handleTabClick = (value: any) => () => {
    tabOpen === value ? setTabOpen('') : setTabOpen(value)
  }

  return (
    <>
      <TabContainer>
        {tabs.map((tab) => {
          return (
            Boolean(tab.name) &&
            Boolean(tab.content) && (
              <TabListItem
                key={tab.name}
                tab={tab}
                onClick={handleTabClick}
                open={tab.name === tabOpen}
              />
            )
          )
        })}
      </TabContainer>
    </>
  )
}

const TabContainer = styled.div.attrs({
  className: 'mb-5',
})``
